import React, { useState } from "react"
import { CSSTransition } from "react-transition-group"
import { useLocale } from "context/locale"
import Label from "components/Label"
import StyledProgram from "./styles.js"

const Program = () => {
  const [circle, setCircle] = useState("renewed")
  const [animation, setAnimation] = useState(false)
  const { t, lang } = useLocale()

  const changeCircle = type => {
    setTimeout(() => {
      setCircle(type)
    }, 250)
    setAnimation(true)
  }

  const circleData = {
    renewed: {
      title: "Renewed",
      desc: t(
        "This garment got a second life. Before that, it was sorted out from the clothes donated by our customers, thoroughly washed and cleaned."
      ),
    },
    repaired: {
      title: "Repaired",
      desc: t(
        "This garment got a second life. Before that, it was sorted out from the clothes donated by our customers, repaired, and then thoroughly washed and cleaned."
      ),
    },
    upcycled: {
      title: "Upcycled",
      desc: t(
        "This garment is made from reused fabrics. This way some unwanted clothes got a second life."
      ),
    },
    revived: {
      title: "Revived",
      desc: t(
        "This garment got saved from oblivion. Before that, for some reason it wasn’t sold: it was soiled, worn traces of use or stayed in the warehouse as one of the last pieces. It was retrieved, washed, cleaned and revived."
      ),
    },
    rental: {
      title: t("Renting"),
      desc: t(
        "This garment is for rent so that it can be used continuously and by more people. After the season, it will get a second life when we will re-introduce it to the market as a part of Wear_Fair program."
      ),
    },
  }

  return (
    <StyledProgram id="circular_model">
      <Label text="#circularity" />
      <div className="main-container">
        <div className="program__container">
          {/* <h2 className="program__header">
            {t("Closed-loop Clothing Programme")}
          </h2> */}
          <img
            className="program__logo"
            src={
              require("images/refresh/4F_MOVING_TOWARDS_CIRCULARITY.svg")
                .default
            }
            alt=""
          />
          <p className="program__subheader">
            {t(
              "Program aiming at closing the loop and transitioning towards circular fashion."
            )}
          </p>
          <p className="program__description">
            {t(
              "It focuses on both designing clothes in a more sustainable way and giving the ones that already exist a second life by renewing, repairing and upcycling."
            )}
          </p>

          <div className="program__circle">
            <div className="program__circle-wrapper">
              <div className="program__circle-description">
                <CSSTransition
                  in={animation}
                  timeout={300}
                  classNames="item"
                  onEnter={() => setAnimation(false)}
                >
                  <div>
                    <strong>{circleData[circle].title}</strong>
                    <p>{circleData[circle].desc}</p>
                  </div>
                </CSSTransition>
              </div>

              <div className="program__circle-image">
                <CSSTransition
                  in={animation}
                  timeout={300}
                  classNames="item"
                  onEnter={() => setAnimation(false)}
                >
                  <img
                    src={
                      require(`images/strategy/program-circle-${circle}-${lang}.svg`)
                        .default
                    }
                    alt=""
                  />
                </CSSTransition>
              </div>
            </div>
            <div className="program__circle-nav">
              <button
                className={circle === "renewed" ? "current" : null}
                onClick={() => changeCircle("renewed")}
              >
                Renewed
              </button>
              <button
                className={circle === "repaired" ? "current" : null}
                onClick={() => changeCircle("repaired")}
              >
                Repaired
              </button>
              <button
                className={circle === "upcycled" ? "current" : null}
                onClick={() => changeCircle("upcycled")}
              >
                Upcycled
              </button>
              {/* <button
                className={circle === "revived" ? "current" : null}
                onClick={() => changeCircle("revived")}
              >
                Revived
              </button> */}
              {/* <button
                className={circle === "rental" ? "current" : null}
                onClick={() => changeCircle("rental")}
              >
                {t("Renting")}
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </StyledProgram>
  )
}

export default Program
